import { render, staticRenderFns } from "./BindBank.vue?vue&type=template&id=7f173b24&scoped=true"
import script from "./BindBank.vue?vue&type=script&lang=js"
export * from "./BindBank.vue?vue&type=script&lang=js"
import style0 from "./BindBank.vue?vue&type=style&index=0&id=7f173b24&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f173b24",
  null
  
)

export default component.exports